<script>
import DatePicker from 'vue2-datepicker';
import '../../../../sass/datepicker.css';
export default {

  props: {
    'date' : Date,
    'placeholder' : String,
    'notBefore' : {
      type: String,
      default: null
    },
    'error' : Boolean,
    'onClear' : { 
      type: Function,
      default: function() {}
    }
  },

  mounted: function() {
  },

  components: {
    DatePicker
  },

  watch: {
    selectedDate: function (newVal, oldVal) {
      let date = newVal;
      // format type for sending to server
      if (newVal) {
        date = moment(date).format("YYYY-MM-DD HH:mm:ss");
      }
      this.$emit('selected-date', date);
    },

    notBefore: function(newVal, oldVal) {
      if (!this.date) {
        this.selectedDate = moment(this.notBefore).add(7, 'days')
      }
    }
  },


  data() {
    return {
      selectedDate: this.date,
      defaultValue: this.date ? moment(this.date).toDate() : null,

      lang: {
        days: [
          'Sun',
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat'
        ],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: [
          'next 7 days',
          'next 30 days',
          'previous 7 days',
          'previous 30 days'
        ],
        placeholder: {
          date: this.placeholder,
        }
      },
      // custom range shortcuts
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [
              new Date(),
              new Date()
            ]
          }
        }
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      }
    }
  }
}

</script>

<template>
<div>
    <date-picker v-model="selectedDate"
                 :default-value="defaultValue"
                 :shortcuts="shortcuts"
                 :lang="lang"
                 :input-class="error ? 'form-control is-invalid' : 'form-control'"
                 
                 :format="'MMMM DD YYYY'"
                 @clear="onClear"
                 :not-before="notBefore"></date-picker>
</div>

</template>
